"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@cian/config/browser");
var urljoin = require("url-join");
var internal_1 = require("./internal");
var logger = null;
/**
 * Инициализация браузерного логгера
 *
 * @export
 * @returns {ILogger}
 */
function init() {
    if (logger) {
        return logger;
    }
    var config = browser_1.init();
    var baseUrl = config.get('logger.browser.baseUrl');
    var pathApi = config.get('logger.browser.pathApi');
    var context = new internal_1.Context({ config: config });
    var messageWriter = new internal_1.ConsoleWriter();
    /**
     * Это сделано для того, чтобы локально ошибки сыпались только в консоль
     */
    var errorWriter = baseUrl && pathApi ? new internal_1.HttpTransport(urljoin(baseUrl, pathApi)) : new internal_1.ConsoleWriter();
    logger = new internal_1.BrowserLogger({ messageWriter: messageWriter, errorWriter: errorWriter, context: context });
    return logger;
}
exports.init = init;
/**
 * Возвращает инстанс браузерного логгера. Если логгер был не инициализирован, то выбрасывает исключение
 *
 * @export
 * @returns {ILogger}
 */
function getLogger() {
    if (!logger) {
        throw new Error('Logger must be initialized before accessing it. Forgot to call init() before accessing logger?');
    }
    return logger;
}
exports.getLogger = getLogger;
//# sourceMappingURL=interface.js.map